export enum EChallengesStatus {
  ACTIVE = 'Ativo',
  INACTIVE = 'Inativo',
}

export enum ECriterion {
  LESS_EQUAL = 'LESS_EQUAL',
  GREATER_EQUAL = 'GREATER_EQUAL',
  EQUAL = 'EQUAL',
  DIFFERENT = 'DIFFERENT',
  BETWEEN = 'BETWEEN',
}

export enum EPillar {
  SECURITY = 'SECURITY',
  ESG = 'ESG',
  PREDICTIVE = 'PREDICTIVE',
  SAFE = 'SAFE',
}

export enum EChallengesType {
  PERSONALIZED = 'PERSONALIZED',
  DEFAULT = 'DEFAULT',
}

export interface IChallenges {
  id?: string | any;
  name: string;
  description?: string;
  criterion: ECriterion;
  criterionValue: number;
  criterionSecondValue: number;
  pillar: EPillar;
  variableId: number;
  points: number;
  uniqueExecute: boolean;
  active: boolean;
  validUntil: string;
  type: EChallengesType;
}
